import { Dimensions, Platform } from "react-native";

const { width, height } = Dimensions.get("window");

export const Frame = {
  width,
  height,
};
export const IsMobile = Frame.width <= 768;

export enum ButtonType {
  primary,
  secondary,
  outline,
}
